// components/modals/web-modals/NewsletterModal.jsx

import BaseModalWeb from './BaseModalWeb';
import NewsletterFormComponent from './components/NewsletterFormComponent';

const NewsletterModal = ({ isOpen, onRequestClose }) => {
  return (
    <BaseModalWeb
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Newsletter Subscription Modal"
      className="ReactModal__Content modal--web modal--500px"
      overlayClassName="ReactModal__Overlay modal-overlay--web"
    >
      <NewsletterFormComponent onSuccess={onRequestClose} />
    </BaseModalWeb>
  );
};

export default NewsletterModal;